import { MainColor } from '../../palette';

export const getRichTextFieldThemeConfig = () => {
  return {
    container: {
      borderColor: 'coolGrey30' as MainColor,
    },
    divider: {
      borderColor: 'coolGrey30' as MainColor,
    },
    floatingLink: {
      inputBackgroundColor: 'white95' as MainColor,
      borderColor: 'coolGrey30' as MainColor,
    },
    display: {
      border: 'coolGrey10' as MainColor,
      detailBackground: 'coolGrey5' as MainColor,
    },
  };
};

export type RichTextFieldTheme = ReturnType<typeof getRichTextFieldThemeConfig>;
